import { isUrl } from '@utils/url';
import React, { ComponentType, FC } from 'react';

import { WITH_URL_VALIDATION_ERROR } from '../constants';
import { ComponentWithURLProps } from '../types';

export const withURLValidation = <P extends ComponentWithURLProps>(
    WrappedComponent: ComponentType<P>
) => {
    const WithURLValidation: FC<P> = (props) => {
        const { url } = props;

        if (!isUrl(url)) {
            console.warn(WITH_URL_VALIDATION_ERROR);
            return null;
        }

        return <WrappedComponent {...props} />;
    };

    return WithURLValidation;
};
